export default "__VITE_ASSET__BiXE7Yz7__"